const getDidoxOwnerType = () => {

    return [
        {'code': 0, 'name': 'Кирувчи'},
        {'code': 1, 'name': 'Чиқувчи'}
    ]

};
export default getDidoxOwnerType;